<div class="option-group">
  <ng-content></ng-content>
</div>
